import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-general-5v1',
  templateUrl: './5v1.component.html',
})
export class VbGeneral5v1Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
